<div class="select" ><mat-checkbox *ngIf="!(isLoadingCanvas$ | async)" [disabled]="sideSelect" [formControl]="previewSelectedControl" color="primary">Select page {{ pageNumber }}</mat-checkbox></div>
<div [class.selected]="isSelected$ | async" (click)="openPage()" class="container">
  <canvas #canvas></canvas>
  <canvas class="upper-canvas" #upperCanvas></canvas>
</div>
